import React from 'react';
import PropTypes from 'prop-types';
import { translate, Translate } from 'react-i18nify';

import ReactGA from 'react-ga';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

const styles = theme => ({
  tableTd: {
    paddingRight: '5px',
  },
  menuOptions: {
    color: '#5F5F5F',
    padding: '10px 25px',
    '& svg': {
      height: '20px',
      marginRight: '25px',
    },
  },
});

class MoreOption extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, device, openSupportToolModal } = this.props;
    const { anchorEl } = this.state;

    return (
      <div className={classes.tableTd}>
        <IconButton
          data-test-id="more-icon"
          aria-label="More"
          aria-owns={null}
          aria-haspopup="true"
          onClick={this.handleClick}
          disabled={false}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem
            data-test-id="support-tool"
            className={classes.menuOptions}
            onClick={() => {
              this.handleClose();
              openSupportToolModal(device);
            }}
          >
            <Translate value="components.supportTool.title" />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

MoreOption.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MoreOption);
